<template>
  <div class="layout-wrapper">

    <TopMenu :links="toplevellinks" :fleetselector="false" />

    <div class="maincontent">
      <router-view class="w-full h-full" />
    </div>

  </div>
</template>

<script setup>

import { ref } from "vue";

const toplevellinks = ref([
  {label: "Devices", adminonly: false, to: "/devices"}
]);

</script>
